<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
const converterConfig = parseAndValidateConverterConfig('lottie-to-jpg-converter', 'Lottie → JPG');

// Event handlers
function handleBatchCreated(batchId: string) {
  console.log('[Lottie JPG Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[Lottie JPG Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[Lottie JPG Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[Lottie JPG Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[Lottie JPG Converter] Credits updated:', credits);
}
</script>
